import { Component, OnInit } from '@angular/core';
import { Validators, FormControl, FormGroup } from '@angular/forms';
import {DynamicDialogRef} from 'primeng/api';
import {DynamicDialogConfig} from 'primeng/api';
import { NewmemberService } from '../../services/newmember.service';
import {MessageService} from 'primeng/api';
import { DialogService } from 'primeng/api';

@Component({
  selector: 'app-addressform',
  templateUrl: './addressform.component.html',
  styleUrls: ['./addressform.component.css'],
  providers: [DialogService]
})
export class AddressformComponent implements OnInit {
  pincode: RegExp = /[^(a-z)]{6}$/;
  populateForm: any = {};

  babForm: FormGroup;
  babFormValid: boolean = true;

  bamForm: FormGroup;
  bamFormValid: boolean = true;
  baStateList: any = [];
  baCityList: any = [];
  baCountyList: any = [];
  baStateDropDisable:boolean = true;
  baCityDropDisable:boolean = true;
  maStateList: any = [];
  maCityList: any = [];
  maCountyList: any = [];
  maStateDropDisable:boolean = true;
  maCityDropDisable:boolean = true;

  ba: any = {};

  constructor(public nms: NewmemberService, public ref: DynamicDialogRef, public config: DynamicDialogConfig, public messageService: MessageService) { }

  ngOnInit() {
    this.populateForm = this.config.data.populateForm;
    this.ba = this.config.data.memberDetails.memberAddresses;
    this.babForm = new FormGroup({
      buildingno: new FormControl('', Validators.compose([
        Validators.required
      ])),
      streetname: new FormControl('', Validators.compose([
        Validators.required
      ])),
      city: new FormControl('', Validators.compose([
        Validators.required
      ])),
      state: new FormControl('', Validators.compose([
        Validators.required
      ])),
      county: new FormControl('', Validators.compose([
        Validators.required
      ])),
      pinno: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern('^[0-9]{6}$')
      ]))
    });
    this.bamForm = new FormGroup({
      mbuildingno: new FormControl('', Validators.compose([
        Validators.required
      ])),
      mstreetname: new FormControl('', Validators.compose([
        Validators.required
      ])),
      mcity: new FormControl('', Validators.compose([
        Validators.required
      ])),
      mstate: new FormControl('', Validators.compose([
        Validators.required
      ])),
      mpinno: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern('^[0-9]{6}$')
      ])),
      mcounty: new FormControl('', Validators.compose([
        Validators.required
      ])),
      mailsameasbusiness: new FormControl(false)
    });
    this.baStateList = [];
    this.baStateList.push(this.ba.businessStateProvCode);

    this.baCityList = [];
    this.baCityList.push(this.ba.businessCityName);

    this.maStateList = [];
    this.maStateList.push(this.ba.mailingStateProvCode);

    this.maCityList = [];
    this.maCityList.push(this.ba.mailingCityName);

    if (this.ba.businessPostalCode != null) {
      this.getCountyByPincode(this.ba.businessPostalCode, 'business');
    }
    if (this.ba.mailingPostalCode != null) {
      this.getCountyByPincode(this.ba.mailingPostalCode, 'mailing');
    }
  }

  getCountyByPincode(pincode, addressType) {
    if (pincode != undefined && pincode.toString().length == 6) {
      this.nms.getLocationByPincode(pincode).subscribe((res: any) => {

        if (res.code === "SUCCESS") {
          if (addressType === 'business') {
            this.baCountyList = [];
            this.baCountyList = res.response.countyNames;
            if (this.baCountyList.indexOf(this.ba.businessCountyName) < 0) {
              this.baCountyList.push(this.ba.businessCountyName);
            }
          } else if (addressType === 'mailing') {
            this.maCountyList = [];
            this.maCountyList = res.response.countyNames;
            if (this.maCountyList.indexOf(this.ba.mailingCountyName) < 0) {
              this.maCountyList.push(this.ba.mailingCountyName);
            }
          } 
        } 
      });
    }
  }

  saveBA() {
    if((this.babForm.valid && (this.bamForm.valid || this.bamForm.value.mailsameasbusiness)) && (this.babForm.dirty || this.bamForm.dirty)) {
      this.nms.saveBA(this.ba).subscribe((res: any) => {
        if(res.code == "SUCCESS") {
          this.ref.close(true);
        }
      }, err => {
        console.error('ERROR', err);
      });
    } else {
      if(!this.babForm.valid) {
        this.babFormValid = false;
      }
      if(!this.bamForm.valid && !this.bamForm.value.mailsameasbusiness) {
        this.bamFormValid = false;
      }
      if(!this.babForm.valid || (!this.bamForm.valid && !this.bamForm.value.mailsameasbusiness)) {
        this.msgToast('Please fill all mandatory fields');
      }
      if (!this.babForm.dirty) {
        this.msgToast('No changes made');
      }
    }
  }

  msgToast(msg) {
    this.messageService.add({ severity: 'error', summary: 'Edit Member', detail: msg });
  }


  changeState(addressType, state){
    if (addressType === "business") {
      this.baCityList = [];
    } else if (addressType === "mailing") {
      this.maCityList = [];
    }
    this.nms.getCityByState(state).subscribe((res: any) => {
      if (res.code === "SUCCESS") {
        if (addressType === "business") {
          this.baCityList = res.response;
        } else if (addressType === "mailing") {
          this.maCityList = res.response;
        }       
      }
    });
  }

  changeCity(addressType, cityName){
    if (addressType === "business") {
      this.baCountyList = [];
    } else if (addressType === "mailing") {
      this.maCountyList = [];
    }

    this.nms.getCountyListByCity(cityName).subscribe((res: any) => {
      if (res.code === "SUCCESS") {
        if (addressType === "business") {
          this.baCountyList = res.response;
        } else if (addressType === "mailing") {
          this.maCountyList = res.response;
        } 
      }
    });
  }


  populateBusinessLocation(res) {
    this.ba.businessStateProvCode = "";
    this.ba.businessCityName = "";
    this.ba.businessCountyName = "";
    this.baStateList = [];
    this.baCityList = [];
    this.baCountyList = [];

    this.baStateDropDisable = true;
    this.baCityDropDisable = true;   
    this.baStateList.push(res.stateName);
    this.ba.businessStateProvCode = res.stateName;
    this.baCityList.push(res.cityName);
    this.ba.businessCityName = res.cityName;
    this.baCountyList = res.countyNames;
  }


  populateMailingLocation(res) {
    this.ba.mailingStateProvCode = "";
    this.ba.mailingCityName = "";
    this.maStateList = [];
    this.maCityList = [];
    this.maCountyList = [];
    this.ba.mailingCountyName = "";

    this.maStateDropDisable = true;
    this.maCityDropDisable = true;    
    this.maStateList.push(res.stateName);
    this.ba.mailingStateProvCode = res.stateName;
    this.maCityList.push(res.cityName);
    this.ba.mailingCityName = res.cityName;
    this.maCountyList = res.countyNames;
  }

  getLocationByPincode(pincode, addressType, isDirty){
    if (!isDirty) {
      return;
    }
    if (pincode != undefined && pincode.toString().length == 6) {
      this.nms.getLocationByPincode(pincode).subscribe((res: any) => {
     
        if (res.code === "SUCCESS") {
          if (addressType === 'business') {      
            this.populateBusinessLocation(res.response);
          } else if (addressType === 'mailing') {      
            this.populateMailingLocation(res.response);
          }
        } else {
          if (addressType === 'business') {
            this.baStateList = [];
            this.baCityList = [];
            this.baCountyList = [];
            this.baStateDropDisable = false;
            this.baCityDropDisable = false;
            this.ba.businessCityName = "";
            this.ba.businessStateProvCode = "";
            this.ba.businessCountyName = "";
            this.baStateList = this.populateForm.states;
          } else if (addressType === 'mailing') {      
            this.maStateList = [];
            this.maCityList = [];
            this.maStateDropDisable = false;
            this.maCityDropDisable = false;
            this.ba.mailingCityName = "";
            this.ba.mailingStateProvCode = "";
            this.ba.mailingCountyName = "";
            this.maStateList = this.populateForm.states;
          } 
          
        }
      });
    }
  }
}

